// extracted by mini-css-extract-plugin
export default {"boxBody":"boxBody-sG_2N","hidden":"hidden-jX6gL"};